






















import { downloadAttachments } from "@/utilities/index";
export default {
    name: 'attachmentBodyPreview',
    props: {
        attachment: {
            type: Object,
            required: true,
            default: () => {
                return {};
            }
        },
        previewOnClick: {
            type: Boolean,
            required: false,
            default: () => false
        }
    },
    computed: {
        isImage() {
            return this.attachment?.type?.includes('image');
        },
        imagePreviewUrl() {
            return this.attachment?.metadata?.file_url || '';
        }
    },
    methods: {
        handelImageError(e: any) {
            e.target.src = require('@/assets/image-placeholder.png');
        },
        previewAttachment() {
            this.$emit("previewAttachment");
        },
        async downloadAttachment() {
            if (!this.attachment?.metadata?.file_url) return;
            downloadAttachments(this.attachment.metadata.file_url, this.attachment.title);
        },
        handleClickCard() {
            if (this.previewOnClick) this.previewAttachment();
        }
    }
};
